import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';
import { setIsMapDataUpdateNeeded } from '@slices/map';

import { updateAsset } from '@api/assets';

import { TAssetFormDTO } from '@interfaces/assets/dto/assetsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET, ASSETS, FILTER_THRESHOLDS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAsset = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateAsset,
		isLoading: isLoadingUpdateAsset,
	} = useMutation<{ id: string; data: TAssetFormDTO }>({
		mutationKey: [ASSET, id],
		mutationFn: updateAsset,
		onSuccess: () => {
			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}

			dispatch(setIsMapDataUpdateNeeded(true));
			dispatch(setSnackbar({
				message: responseMessages.updatedAsset,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([ASSET]),
				queryClient.invalidateQueries([ASSETS]),
				queryClient.invalidateQueries([FILTER_THRESHOLDS]),
			];
		},
	});

	return { handleUpdateAsset, isLoadingUpdateAsset };
};
